module.exports = __webpack_public_path__ + "static/carousel-arrow-351e53185a3ef12e3e24762a5cd35817.svg";